import RequestPageTwo from "./RequestPageTwo";

const AnnualExFundReq = () => {
    return (
        <RequestPageTwo title="Annual Expense Fund Request"
            fetchUrl="/get-annual-expense-fund-requests"
            editEndpoint="update-annual-expense-fund-requests"
            deleteEndpoint="delete-annual-expense-fund-requests"
            statusEndpoint="update-annual-expense-fund-requests" />
    );
}

export default AnnualExFundReq;
